import { render } from "./ScheduleEventMailModal.vue?vue&type=template&id=15661246&scoped=true&lang=pug"
import script from "./ScheduleEventMailModal.vue?vue&type=script&lang=js"
export * from "./ScheduleEventMailModal.vue?vue&type=script&lang=js"

import "./ScheduleEventMailModal.vue?vue&type=style&index=0&id=15661246&scoped=true&lang=css"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15661246"]])

export default __exports__